export default __webpack_public_path__ + "static/media/culture-icon.c7a357cb.svg";